export default "__VITE_ASSET__CeRZnFjw__"